import * as React from 'react';

import { Accordion } from '../components/Accordion';
import { Image } from '../components/Image';
import { WarningBlock } from 'src/components';
import users1 from '../screenshots/UserManaging/adduser.jpg';

const sections = [
  {
    question: 'How can I create new user logins?',
    answer: (
      <>
        <WarningBlock left={true}>
          <p>
            You need user admin rights in order to be able to create new user
            logins.
          </p>
        </WarningBlock>
        <ol>
          <li>
            <p>
              If you have been granted user admin rights, you will see the
              „Admin Area“ page in the menu. Navigate to the „Users“ section:
            </p>
            <Image src={users1} />
          </li>
          <li>
            <p>Click on „Add new“:</p>
          </li>
          <li>
            <p>Fill in the required email-adress in the „username“ field.</p>
          </li>
          <li>
            <p>Choose user roles.</p>
            <p>
              If you check the „SuperAdmin“, „ContentAdmin“ or „UserAdmin“
              boxes, then this user will have access to the admin interface.
            </p>
            <p>
              If you leave the checkboxes empty, the user will receive standard
              user rights and will only be able to create, duplicate and export
              trackinglinks and shortlinks.
            </p>
          </li>
          <li>
            <p>
              Select which profile (market) the user will have access to and to
              make sure that „Visible“ has been selected.
            </p>
          </li>
          <li>
            <p>
              Click on „Save“. The user will be created and an automatic
              notification will be sent to the new user, including a link to the
              tool and password reset functionality.
            </p>
          </li>
        </ol>
      </>
    ),
  },
  {
    question: 'What user roles are there?',
    answer: (
      <>
        <ul>
          <li>
            <p>
              <strong>Standard user</strong>: can search, create, duplicate and
              export trackinglinks, shortlinks and QR codes.
            </p>
          </li>
          <li>
            <p>
              <strong>User Admin</strong>: has standard user rights as well as
              access to the „Users“ admin interface. They are able to create new
              user logins in the tool.
            </p>
          </li>
          <li>
            <p>
              <strong>Content Admin</strong>: has standard user rights as well
              as access to the „Parameters“ and „Items“ admin interface. They
              are able to create new parameters and items (=dropdown values) in
              the tool.
            </p>
          </li>
          <li>
            <p>
              <strong>Super Admin</strong>: has all available access rights.
              Super Admin roles are usually only given to the Link Manager
              support team.
            </p>
          </li>
        </ul>
      </>
    ),
  },
];

export const UserManaging = ({ index }: { index: number }) => (
  <div>
    <h2 className="mt-12 mb-6">{index}. Managing users</h2>
    {sections.map(({ question, answer }, subindex) => (
      <Accordion
        title={`${index}.${subindex + 1}. ${question}`}
        content={answer}
        key={subindex}
      />
    ))}
  </div>
);



// WEBPACK FOOTER //
// ./src/views/Tutorial/sections/UserManaging.tsx